function setup() {
    const container = document.querySelector('[data-rotating-banners-container]');

    if (!container) {
        return;
    }

    const transitionTime = parseInt(container.getAttribute('data-transition-time'));
    const banners = container.querySelectorAll('[data-rotating-banners-item]');
    let currentIndex = 0;

    showCurrentBanner();
    setInterval(moveToNextBanner, transitionTime);

    function hideAllBanners() {
        banners.forEach(banner => {
            banner.style.display = 'none';
        });
    }

    function showCurrentBanner() {
        hideAllBanners();
        banners[currentIndex].style.display = 'block';
    }

    function moveToNextBanner() {
        currentIndex = (currentIndex + 1) % banners.length;
        showCurrentBanner();
    }
}

export default {setup};


